<template lang="pug">
  #freights.center-panel.md-scrollbar.md-theme-default
    .md-layout.heading
        //- фильтр
        //#filter(style="flex-grow: 3")
          .sort
            md-field(md-theme="white")
              md-select(v-model="status")
                md-option(value="all") Все
                md-option(v-for="status in trackingStatuses" v-bind:value="status.id" v-bind:key="status.id") {{ status.name }}
          md-icon add
          input.text(type="text" placeholder="Поиск..." v-model="searchString" v-on:keyup="dropdown"  v-on:keyup.enter="filter")
          md-button.small.md-icon-button.close.md-dense(@click="resetFilter" v-if="searchString.length"): md-icon close
          ul.dropdown.md-elevation-2(v-if="showSearchDropdown && searchString")
            li(@click="filterByDeal(deal)" v-for="deal in deals") Заявка #[md-chip {{ 'номер ' + deal.id}}]
            li(@click="filter") Поиск "{{ searchString }}"
    md-content.md-elevation-1(md-theme="white" v-loader-overlay="{id: 'get-freight-list', value: progress}")
      stock-menu
      .md-flex.no-select(md-theme="white")
        sort-table(ref="table" v-bind:columns="tableColumns" v-model="allFreights" v-on:expand="onExpand" v-on:refresh="getFreights" v-bind:per-page="perPage" v-bind:total="freightAmount" expandable table-id="freights")
          template(slot="select" slot-scope="scope")
            md-checkbox(v-model="selectedFreights" v-bind:value="scope.item.id")
          template(slot="status" slot-scope="scope")
            span(v-if="scope.item.status" v-bind:style="'color: ' + scope.item.status.color") {{ scope.item.status.name }}
            span(v-if="!scope.item || !scope.item.status") Не установлен
          template(slot="actions" slot-scope="scope")
            span
              md-button.md-icon-button.md-dense(v-if="scope.item.deal_id" v-bind:to="{ name: 'DealEdit', params: {dealid: scope.item.deal_id} }"): md-icon content_paste
              md-tooltip(md-direction="top") К заявке
          template(slot="deal_id" slot-scope="scope")
            span( v-if="scope.item.deal && scope.item.deal.traking_number") {{scope.item.deal.traking_number}}
            span( v-if="!scope.item.deal || !scope.item.deal.traking_number") Не установлен

          template(slot="from" slot-scope="scope")
            span(v-if="scope.item.deal && scope.item.deal.from_address && scope.item.deal.from_address.address")
              span {{scope.item.deal.from_address.address}}
            span(v-else)
              span(v-if="scope.item.deal && scope.item.deal.from_stock && scope.item.deal.from_stock.name") {{scope.item.deal.from_stock.name}}
              span(v-else): b Склад/Адрес не установлен

          template(slot="to" slot-scope="scope")
            span(v-if="scope.item.deal && scope.item.deal.to_address && scope.item.deal.to_address.address") {{scope.item.deal.to_address.address}}
            span(v-else)
              span(v-if="scope.item.deal && scope.item.deal.to_stock && scope.item.deal.to_stock.name") {{scope.item.deal.to_stock.name}}
              span(v-else): b Склад/Адрес не установлен

          template(slot="expanded" slot-scope="scope")
            .tracking-container.md-layout.md-gutter
              .timeline-container.md-layout-item.md-size-33
                .timeline
                  div.timeline-row(v-for="tracking in scope.item.tracking")
                    .date-time
                      .date {{moment(tracking.date).format('DD.MM.YYYY')}}
                      //.date {{moment(tracking.date).format('MMMM')}}
                      //.date {{moment(tracking.date).format('dddd')}}
                      .time {{moment(tracking.date).format('HH:mm')}}
                    .dot-container
                      .dot
                        //.tooltip
                          .delete
                            md-button.md-icon-button.small.md-dense(@click.stop="showDeleteDialog(tracking)"): md-icon close
                            md-tooltip(md-direction="top") Удалить
                      .dot-line
                    .timeline-content
                      .status(v-if="tracking.status")
                        .text {{ tracking.status.name }}
                      .timeline-text-content
                        .stock(v-if="tracking.stock") Склад: {{ tracking.stock.name }}
                        .responsible(v-if="tracking.responsible") Ответственный: {{ tracking.responsible.login }}
                md-button.md-dense.small(@click="addTracking(scope.item.id)") Добавить отметку
              .freight-info.md-layout-item.md-size-33
                .content
                  h4  Данные груза
                  display-value(v-bind:inline="true" v-bind:value="(scope.item.traking_number)" v-bind:label="'Номер отслеживания'")
                  display-value(v-bind:inline="true" v-bind:value="((scope.item.status_id) ? scope.item.status.name : 'Не установлен')" v-bind:label="'Статус'")
                  display-value(v-bind:inline="true" v-bind:value="(scope.item.weight + ' кг.')" v-bind:label="'Вес'")
                  //display-value(v-bind:inline="true" v-bind:value="((scope.item.departure_date) ? moment(scope.item.departure_date, 'DD.MM.YYYY HH:ss:mm').format('Do MMMM YYYY (DD.MM.YYYY)') : 'Не установленна')" v-bind:label="'Планируемая дата забора'")
                  display-value(v-bind:inline="true" v-bind:value="(scope.item.size + ' ' + scope.item.size_units + '.')" v-bind:label="'Объём'")
                  display-value(v-bind:inline="true" v-bind:value="((scope.item.doom) ? 'Да' : 'Нет')" v-bind:label="'Обрешётка'")
                  display-value(v-bind:inline="true" v-bind:value="(scope.item.price + ' руб.')" v-bind:label="'Цена'")
                  display-value(v-bind:inline="true" v-bind:value="((scope.item.factory_package) ? 'Да' : 'Нет')" v-bind:label="'Заводская упаковка'")
                  display-value(v-bind:inline="true" v-bind:value="((scope.item.oversized) ? 'Да' : 'Нет')" v-bind:label="'Негабаритный груз'")
                  display-value(v-bind:inline="true" v-bind:value="((scope.item.seats_number) ? scope.item.seats_number : 'Не установленно')" v-bind:label="'Количество мест'")
                  display-value(v-bind:inline="true" v-bind:value="((scope.item.forwarder_id) ? scope.item.forwarder.login : 'Не установлен')" v-bind:label="'Ответственный экспедитор'")
                  display-value(v-bind:inline="true" v-bind:value="((scope.item.description) ? scope.item.description : 'Не установленно')" v-bind:label="'Описание'")
                  br
                  h4(v-if="scope.item.services && scope.item.services.length")  Дополнительные услуги
                  div(v-if="scope.item.services && scope.item.services.length")
                    display-value(v-for="(item, i) in scope.item.services" v-bind:key="i" v-bind:inline="true" v-bind:value="(['select', 'radio'].indexOf(item.service.type)+1) ? item.name : 'Да'" v-bind:label="item.service.name")

              .deal-info.md-layout-item.md-size-33(v-loader-overlay.sync="{value: (!scope.item.deal_expand || !scope.item.deal_expand.id), id: scope.item.id}")
                .content
                  div.info-header
                    h4  Данные заявки
                    router-link(v-bind:to="{name: 'DealEdit', params: {dealid: scope.item.deal_id }}") Перейти к заявке

                  div(v-if="scope.item && scope.item.deal_expand")
                    display-value(v-bind:value="(scope.item.deal_expand.traking_number) ? scope.item.deal_expand.traking_number : 'Не установлен'" v-bind:label="'Номер отслеживания'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.status_id) ? scope.item.deal_expand.status.name : 'Не установлен'" v-bind:label="'Статус'")
                    display-value(v-bind:value="(scope.item.deal_expand.forwarding_date_from) ? moment(scope.item.deal_expand.forwarding_date_from).format('Do MMMM YYYY (DD.MM.YYYY)') : 'Не установленна'" v-bind:label="'Планируемая дата экспедирования в пункте отправления'")
                    display-value(v-bind:value="(scope.item.deal_expand.forwarding_date_to) ? moment(scope.item.deal_expand.forwarding_date_to).format('Do MMMM YYYY (DD.MM.YYYY)') : 'Не установленна'"   v-bind:label="'Планируемая дата экспедирования в пункте назначения'")
                    display-value(v-bind:inline="true" v-bind:value="scope.item.deal_expand.price + ' руб.'" v-bind:label="'Цена'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.from_stock_id) ? scope.item.deal_expand.from_stock.name : 'Не установлен'" v-bind:label="'Склад отправления'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.to_stock) ? scope.item.deal_expand.to_stock.name : 'Не установлен'" v-bind:label="'Склад назначения'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.from_address_id) ? scope.item.deal_expand.from_address.address : 'Не установлен'" v-bind:label="'Адрес отпправления'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.to_address_id) ? scope.item.deal_expand.to_address.address : 'Не установлен'" v-bind:label="'Адрес назначения'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.forwarder_from_id) ? scope.item.deal_expand.forwarder_from.login : 'Не установлен'" v-bind:label="'Экспедитор в пункте отправления'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.forwarder_to_id) ? scope.item.deal_expand.forwarder_to.login : 'Не установлен'" v-bind:label="'Экспедитор в пункте назначения'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.responsible_id) ? scope.item.deal_expand.responsible.login : 'Не установлен'" v-bind:label="'Ответственный менеджер'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.sender_id) ? scope.item.deal_expand.sender.name : 'Не установлен'" v-bind:label="'Отправитель'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.recipient_id) ? scope.item.deal_expand.recipient.name : 'Не установлен'" v-bind:label="'Получатель'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.applicant_id) ? scope.item.deal_expand.applicant.name : 'Не установлен'" v-bind:label="'Заявитель'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.payer_id) ? scope.item.deal_expand.payer.name : 'Не установлен'" v-bind:label="'Плательщик'")
                    display-value(v-bind:inline="true" v-bind:value="(scope.item.deal_expand.executor_company_id) ? scope.item.deal_expand.executor.name : 'Не установлен'" v-bind:label="'Перевозчик'")

            //div
            //.timeline
              .points(v-bind:class="{ 'min-width': scope.item.tracking.length > 1 }" v-bind:style="{ width: scope.item.tracking.length > 1 ? (scope.item.tracking.length * 10) + '%' : false }" v-if="typeof scope.item.tracking != 'undefined'")
                .start {{ moment(scope.item.tracking[0].date).format('DD.MM.YYYY') }}
                .end(v-if="scope.item.tracking.length > 1") {{ moment(scope.item.tracking[scope.item.tracking.length - 1].date).format('DD.MM.YYYY') }}
                .point.md-elevation-1(v-for="tracking in scope.item.tracking" v-bind:key="tracking.id" v-bind:style="{ left: 'calc(' + tracking.offsetString + ' - 5px)' }" v-on:click="editTracking(tracking)")
                  .tooltip
                    .delete
                      md-button.md-icon-button.small.md-dense(@click.stop="showDeleteDialog(tracking)"): md-icon close
                      md-tooltip(md-direction="top") Удалить
                    .time {{ moment(tracking.date).format('DD.MM.YYYY HH:mm') }}
                    .status(v-if="typeof tracking.status != 'undefined'") {{ tracking.status.name }}
                    .stock(v-if="typeof tracking.stock != 'undefined'") Склад: {{ tracking.stock.name }}
                    .responsible(v-if="typeof tracking.responsible != 'undefined'") Ответственный: {{ tracking.responsible.login }}
              .add-tracking
                md-button.md-icon-button.md-dense.small(@click="addTracking(scope.item.id)"): md-icon add
                md-tooltip(md-direction="top") Добавить статус
    md-dialog#tracking-form(v-bind:md-active.sync="showTrackingForm")
      md-field
        label(for="status_id") Статус
        md-select(v-model="editedTracking.status_id" name="status_id" id="status_id")
          md-option(v-for="status in statuses" v-bind:key="status.id" v-bind:value="status.id") {{ status.name }}
      md-field
        label(for="stock_id") Склад
        md-select(v-model="editedTracking.stock_id" name="stock_id" id="stock_id")
          md-option(v-for="stock in stocks" v-bind:key="stock.id" v-bind:value="stock.id") {{ stock.name }}
      md-field
        label(for="responsible_id") Ответственный
        md-select(v-model="editedTracking.responsible_id" name="responsible_id" id="responsible_id")
          md-option(v-for="user in usersOfStock" v-bind:key="user.pivot.user_id" v-bind:value="user.pivot.user_id") {{ user.login }}
      md-field(v-bind:class="{ 'md-invalid': errors.has('date'), 'md-has-value': editedTracking.date }")
        label Дата
        datetime(v-model="editedTracking.date" input-class="md-input" type="datetime" v-bind:use12-hour="false" v-bind:week-start="1" v-bind:phrases="{ ok: 'Ок', cancel: 'Отмена' }")
        md-button.md-icon-button.md-dense(@click="editedTracking.date = ''"): md-icon close
        span.md-error(v-show="errors.has('date')") {{ errors.first('date') }}
      md-dialog-actions
        md-button(class="md-accent" @click="showTrackingForm = false") Отмена
        md-button(class="md-primary" @click="saveTracking") Сохранить
    md-dialog(v-bind:md-active.sync="deleteDialog" md-theme="white")
      md-dialog-title Удалить трекинговую отметку?
      md-dialog-actions
        md-button.md-primary(@click="deleteDialog = false") Отмена
        md-button.md-primary(@click="deleteTracking(trackingToDelete)") Удалить
</template>
<script>
  import moment from "moment";
  import StockMenu from './stock-menu.vue';
  import SortTable from "@/components/SortTable";
  import DisplayValue from "@/components/DisplayValue";
  export default {
    components: {StockMenu, SortTable, DisplayValue},
    metaInfo() {
      return {
        title: 'Отслеживание груза'
      }
    },
    data() {
      return {
        tableColumns: [
          { label: '', field: 'id'},
          { label: '', field: 'select'},
          { label: 'Номер груза', field: 'traking_number', sortable: true },
          { label: 'Номер заявки', field: 'deal_id', sortable: true },
          //{ label: 'Дата забора', field: 'departure_date', sortable: true, default: true },
          { label: 'Статус', field: 'status', sortable: true },
          { label: 'Пункт/Склад отправления', field: 'from', sortable: true },
          { label: 'Пункт/Склад назначения', field: 'to', sortable: true },
          { label: 'Описание', field: 'description', sortable: true },
          { label: '', field: 'actions' },
        ],
        title: 'Груз',
        deleteDialog: false,
        freights: [],
        perPage: 25,
        showTrackingForm: false,
        editedTracking: {},
        trackingToDelete: {},
        searchString: '',
        showSearchDropdown: false,
        deals: [],
        searchFreight: [],
        usersOfStock: [],
        selectedFreights: [],
        allFreights: []
      }
    },
    computed: {
      progress() {
        return this.progressObj['get-freight-list'];
      },
      progressObj() {
        return this.$store.state.progressObj;
      },
      dbFreights() {
          return this.$store.state.stock.freights;
      },
      freightAmount() {
        return this.$store.state.stock.freights_amount;
      },
      totalPages() {
        return Math.ceil(this.freightAmount / this.perPage);
      },
      statuses() {
        return this.$store.state.stock.freight_statuses
      },
      stocks() {
        return this.$store.state.stock.stocks
      },
      trackingStatuses() {
        return this.$store.state.stock.freight_statuses;
      },
      stateSelectedFreight() {
        return this.$store.state.stock.itineraryFreight
      }
    },
    created() {
      //сбрасываем фильтрацию на дефолтные параметры, если никакие не установленны
      let filterParam = {
        ByStatus: this.$cookie.get('filterFreightByStatus'),
        ByStock:  this.$cookie.get('filterFreightByStock'),
        ByDepartureFrom:  this.$cookie.get('filterFreightByDepartureFrom'),
        ByDepartureTo:    this.$cookie.get('filterFreightByDepartureTo'),
        ByForwardingFrom: this.$cookie.get('filterFreightByForwardingFrom'),
        ByForwardingTo:   this.$cookie.get('filterFreightByForwardingTo'),
      };
      if (!filterParam.ByStatus) this.$cookie.set('filterFreightByStatus', 'all');
      if (!filterParam.ByStock) this.$cookie.set('filterFreightByStock', 'all');
      if (!filterParam.ByDepartureFrom) this.$cookie.set('filterFreightByDepartureFrom', 'all');
      if (!filterParam.ByDepartureTo) this.$cookie.set('filterFreightByDepartureTo', 'all');
      if (!filterParam.ByForwardingFrom) this.$cookie.set('filterFreightByForwardingFrom', 'all');
      if (!filterParam.ByForwardingTo) this.$cookie.set('filterFreightByForwardingTo', 'all');

      this.$store.dispatch('stock/getTrackingStatuses');
      this.$store.dispatch('stock/getStocks');

      this.getFreights();

      this.selectedFreights = Object.assign([], this.stateSelectedFreight);
    },
    watch: {
      '$route.name'() {
        this.selectedFreights = Object.assign([], this.stateSelectedFreight);
      },
      '$route.query.search'(newVal) {
        this.getFreights();
      },
      '$store.state.stock.freights'(newVal) {
        if (Object.keys(newVal).length) {
          newVal.forEach((freight) => {
            freight.departure_date = (freight.departure_date) ? moment(freight.departure_date).format('DD.MM.YYYY HH:mm:ss') : '';
            freight.description    = (freight.description) ? freight.description : '';
          })
        }
        this.freights = Object.assign([], newVal);
        this.searchSelectedFreights();
      },
      'editedTracking.stock_id'(val) {
        let existUserIds = [];
        if (this.stocks && this.stocks.length) this.stocks.map(item => {
          if (item.id == val) {
            this.usersOfStock = Object.assign([], item.responsibles);
            existUserIds = item.responsibles.map(item => parseInt(item.pivot.user_id));
          }
        });
        if (existUserIds.indexOf(parseInt(this.editedTracking.responsible_id)) == -1)
          this.editedTracking.responsible_id = null;
      },
      'selectedFreights'(val) {
        if (val.length)
            this.$router.push({name: 'ItineraryFreights'});
        else if(this.selectedFreights && this.selectedFreights.length)
          this.$router.push({name: 'Freights'});
        this.$store.commit('stock/changeItineraryFreight', val);
        this.searchSelectedFreights();
      }
    },
    methods: {
      searchSelectedFreights() {
          this.freights.map(item => {
              if ((this.selectedFreights.indexOf(parseInt(item.id))+1)) item.selected = true;
              else item.selected = false;
          });
      },
      onExpand(index) {
        let freight = this.allFreights[index];
        if (freight.deal_expand && freight.deal_expand.id) return;
        this.getDeal(freight.deal_id).then(deal => {
            deal.from_signature = '';
            deal.to_signature = '';
            if (deal) freight.deal_expand = Object.assign({}, deal);
            this.$set(this.allFreights, index, freight);
        });
      },
      getDeal(id) {
          return this.$store.dispatch('deals/getDealById', {id: id});
      },
      getFreights(page, count, orderBy, orderType) {
        this.$store.commit('showProgressBar', 'get-freight-list');

        let newFilter = {'model': [], 'relation': []};
        if (this.$route.query.search) {
          this.searchString = this.$route.query.search;
          newFilter.model.push(['id', '=', this.$route.query.search]);
          newFilter.model.push('or');
          newFilter.model.push(['description', '%', this.$route.query.search]);
          newFilter.model.push('or');
          newFilter.model.push(['traking_number', '%', this.$route.query.search]);
        }
        if (this.$cookie.get('filterFreightByStatus') !== 'all') {
          if (newFilter.relation && newFilter.relation.length) newFilter.relation.push('and');
          newFilter.relation.push(['status', 'id', '=', this.$cookie.get('filterFreightByStatus')]);
        }
        if (this.$cookie.get('filterFreightByStock') !== 'all') {
          if (newFilter.relation && newFilter.relation.length) newFilter.relation.push('and');
          newFilter.relation.push(['currenttracking','stock_id', '=', this.$cookie.get('filterFreightByStock')]);
        }
        if (this.$cookie.get('filterFreightByDepartureFrom') !== 'all') {
          if (newFilter.model && newFilter.model.length) newFilter.model.push('and');
          newFilter.model.push(['departure_date', '>=', moment(this.$cookie.get('filterFreightByDepartureFrom')).format("YYYY-MM-DD")]);
        }
        if (this.$cookie.get('filterFreightByDepartureTo') !== 'all') {
          if (newFilter.model && newFilter.model.length) newFilter.model.push('and');
          newFilter.model.push(['departure_date', '<=', moment(this.$cookie.get('filterFreightByDepartureTo')).format("YYYY-MM-DD")]);
        }
        if (this.$cookie.get('filterFreightByForwardingFrom') !== 'all') {
          if (newFilter.relation && newFilter.relation.length) newFilter.relation.push('and');
          if (this.$cookie.get('filterFreightByForwardingFrom') === "yes") {
            newFilter.relation.push(['services','service_value_id', '=', '1']);
          } else {
            newFilter.relation.push(['services','service_value_id', '!=', '1']);
          }
        }
        if (this.$cookie.get('filterFreightByForwardingTo') !== 'all') {
          if (newFilter.relation && newFilter.relation.length) newFilter.relation.push('and');
          if (this.$cookie.get('filterFreightByForwardingTo') === 'yes')
            newFilter.relation.push(['services','service_value_id', '=', '2']);
          else newFilter.relation.push(['services','service_value_id', '!=', '2']);
        }
        this.$store.dispatch(
          'stock/getFreights',
          {page: page, order_by: orderBy, order_type: orderType, count: count, filter: newFilter}
        ).then(() => {
            this.$nextTick(() => {
                this.getAllFreights();
                setTimeout(() => this.$store.commit('hideProgressBar', 'get-freight-list'), 1500);
            });
        });
      },
      getAllFreights() {
        if (!this.dbFreights) return;
        let freights = Object.assign([], this.dbFreights);
        freights.forEach(freight => {
            freight.select = false;
            if (freight.tracking) {
                let firstTimestamp = moment(freight.tracking[0].date).unix();
                let lastTimestamp = moment(freight.tracking[freight.tracking.length - 1].date).unix();
                let totalSecondsPass = lastTimestamp - firstTimestamp;
                for (let i = 0; i < freight.tracking.length; i++) {
                    let previousItem = freight.tracking[i - 1];
                    let item = freight.tracking[i];
                    if (previousItem) {
                        let secondsPass = moment(item.date).unix() - moment(previousItem.date).unix();
                        let percents = Math.round(secondsPass / totalSecondsPass * 100, 2);
                        item.offset = percents + previousItem.offset;
                        item.offsetString = item.offset + '%';
                        if (item.offset === previousItem.offset) previousItem.offsetString += ' - 10px ';
                    } else {
                        item.offset = 0;
                        item.offsetString = item.offset + '%';
                    }
                    item.date = moment(item.date).toISOString()
                }
            }
        });

        this.allFreights = Object.assign([], freights);
        return freights;
      },
      addTracking(freight_id) {
        this.editedTracking = {
          id: null,
          freight_id: freight_id
        };
        this.showTrackingForm = true;
      },
      editTracking(tracking) {
        this.editedTracking = tracking;
        this.showTrackingForm = true;
      },
      saveTracking() {
        let action, update = false;
        if (this.editedTracking.id) {
          action = 'stock/updateFreightTracking';
          update = true;
        } else {
          action = 'stock/addFreightTracking';
          update = false;
        }

        this.editedTracking.date = moment(this.editedTracking.date).format('DD.MM.YYYY HH:mm:ss');

        this.$store.dispatch(action, this.editedTracking).then(tracking => {
          if (update) {
            this.$store.state.stock.freights.forEach(freight => { //перебираем все грузы
              if (freight.id == tracking.freight_id) { //если трекинговая отметка относится к этому грузу
                freight.tracking.forEach((freightTracking, index) => { //перебираем трекинговые отметки груза
                  if (freightTracking.id == freight.id) { //находим обновлённую
                    freight.tracking[index] = tracking; //заменяем старую на новую
                  }
                })
              }
            })
          } else {
            this.$store.state.stock.freights.forEach(freight => { //перебираем все грузы
              if (freight.id == tracking.freight_id) { //если трекинговая отметка относится к этому грузу
                if (typeof freight.tracking === 'undefined') { //если не существует отметок
                  freight.tracking = [];
                }
                freight.tracking.push(tracking); //добавляем новую
              }
            })
          }
        });
        this.editedTracking = {id: null};
        this.showTrackingForm = false
      },
      deleteTracking(trackingToDelete) {
        this.$store.dispatch('stock/deleteFreightTracking', { id: trackingToDelete.id })
        this.$store.state.stock.freights.forEach(freight => {
          if (freight.id == trackingToDelete.freight_id) {
            freight.tracking.forEach((tracking, index) => {
              if (tracking.id == trackingToDelete.id) {
                freight.tracking.splice(index, 1)
              }
            })
          }
        })
        this.deleteDialog = false
      },
      showDeleteDialog(tracking) {
        this.deleteDialog = true;
        this.trackingToDelete = tracking;
      },
      getTrackingStatuses() {
        this.store.dispatch('stock/getTrackingStatuses');
      },
    }
  }
</script>
<style lang="sass" src="./freight.sass"></style>



// WEBPACK FOOTER //
// Freight.vue?e675dee2